import React from 'react';
import { translate } from 'react-i18next';
import { Image, StyleSheet, Text, View } from 'react-native';
import scaleImg from '../../assets/images/scale.png';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { WeightTargetHeader } from './weight-target-header';

export const WeightTargetSupportComponent = translate(['weightTarget'], {
  wait: true,
})(({ t, goToPreviousStep, openSmartScaleEcomm }) => {
  return (
    <View style={styles.conainer}>
      <WeightTargetHeader
        title={t('muscleAndStrengthGoalTracking')}
        goToPreviousStep={goToPreviousStep}
      />
      <View style={styles.bodyContainer}>
        <Text style={styles.textBody}>
          {t('muscleAndStrengthGoalTrackingDescriptionText')}
        </Text>
        <View style={styles.actionsContainer}>
          <View style={styles.imageContainer}>
            <Image source={scaleImg} style={styles.image} />
          </View>
          <Button
            title={t('buySmartScaleToTrackMuscleGain')}
            onPress = {openSmartScaleEcomm}
            fontColor={theme.PRIMARY}
            buttonType={ButtonTypes.OUTLINE}
            size={ButtonSize.NORMAL}
            containerStyle={[styles.button, { marginBottom: defaultScale(12) }]}
          />

          <Button
            title={t('ok')}
            onPress={goToPreviousStep}
            fontColor={theme.WHITE}
            buttonType={ButtonTypes.NORMAL}
            size={ButtonSize.NORMAL}
            containerStyle={styles.button}
          />
        </View>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  conainer: {
    flex: 1,
  },
  bodyContainer: {
    paddingHorizontal: defaultScale(15),
    flex: 1,
  },
  textBody: {
    ...theme.textStyle.bodyCopyReg,
    color: theme.GREY_MEDIUM,
  },
  actionsContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingBottom: defaultScale(27),
  },
  button: {
    width: '100%',
  },
  imageContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  image: {
    height: defaultScale(150),
    resizeMode: 'cover',
    aspectRatio: 1,
    marginVertical: defaultScale(15),
  },
});
